import type { AccountPermission as AccountPermissionModel } from '@/adapters/catalogv1.g';

export function extractAccountPermission(model: AccountPermissionModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    permissionRef: model.permission_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountPermission = ReturnType<
  typeof extractAccountPermission
>;
